function setupExpandableDescriptions() {
  console.log('Setting up mobile expandable descriptions...');
  
  document.querySelectorAll('[data-product-id*="-mobile"]').forEach(container => {
    const content = container.querySelector('.description-content');
    const readMoreBtn = container.querySelector('.read-more-btn');
    const readLessBtn = container.querySelector('.read-less-btn');
    const productId = container.dataset.productId;
    
   
    
    if (!content || !readMoreBtn || !readLessBtn) {
      
      return;
    }
    
    const fullHtml = content.innerHTML;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fullHtml;
    const fullText = tempDiv.textContent || tempDiv.innerText || '';
    
    if (fullText.split(' ').length > 25) {
      const words = fullText.split(' ');
      const truncatedText = words.slice(0, 25).join(' ') + '...';
      
      content.dataset.fullContent = fullHtml;
      content.innerHTML = `<p>${truncatedText}</p>`;
      readMoreBtn.style.display = 'inline';
      
 
    }
  });
}

window.toggleDescription = function(productId, showFull) {
  console.log('Toggle called:', productId, showFull);
  
  const container = document.querySelector(`[data-product-id="${productId}"]`);
  const content = container.querySelector('.description-content');
  const readMoreBtn = container.querySelector('.read-more-btn');
  const readLessBtn = container.querySelector('.read-less-btn');
  
  if (showFull) {
    content.innerHTML = content.dataset.fullContent;
    readMoreBtn.style.display = 'none';
    readLessBtn.style.display = 'inline';
  } else {
    const fullText = content.textContent || content.innerText || '';
    const truncatedText = fullText.split(' ').slice(0, 25).join(' ') + '...';
    content.innerHTML = `<p>${truncatedText}</p>`;
    readMoreBtn.style.display = 'inline';
    readLessBtn.style.display = 'none';
  }
};

document.body.addEventListener('click', function (e) {
  if (e.target.closest('.thumbnail-swatch')) {
    setTimeout(setupExpandableDescriptions, 250);
  }
});

// Initial setup on page load
document.addEventListener('DOMContentLoaded', setupExpandableDescriptions);